'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var jurisdictions_constants = require('../jurisdictions.constants.js');
var magicMessaging = require('@gig/magic-messaging');

function getWelcomeNotificationParams(jurisdiction, loginRecords) {
    switch (jurisdiction) {
        case jurisdictions_constants.Jurisdiction.AGCO:
        case jurisdictions_constants.Jurisdiction.DGOJ: {
            if (isFirstLogin(loginRecords)) {
                return {};
            }
            if (!loginRecords[1] || !loginRecords[1].dateCreated) {
                return {};
            }
            var dateStr = loginRecords[1].dateCreated;
            var dateWithTZ = jurisdiction === jurisdictions_constants.Jurisdiction.AGCO ? dateStr + "Z" : dateStr;
            var loginTime = magicCommon.convertToDate(dateWithTZ);
            return {
                lastVisitDate: magicCommon.formatDate(loginTime),
                lastVisitTime: magicCommon.formatTime(loginTime),
            };
        }
        default: {
            return {};
        }
    }
}
function getWelcomeNotificationKey(jurisdiction, loginRecords) {
    switch (jurisdiction) {
        case jurisdictions_constants.Jurisdiction.AGCO: {
            if (isFirstLogin(loginRecords)) {
                return 'login.welcome-notification-limits';
            }
            return 'login.welcome-notification-time';
        }
        case jurisdictions_constants.Jurisdiction.DGOJ: {
            if (isFirstLogin(loginRecords)) {
                return 'login.welcome-notification';
            }
            return 'login.welcome-notification-time';
        }
        default: {
            return 'login.welcome-notification';
        }
    }
}
function getWelcomeNotificationOptions(jurisdiction, loginRecords) {
    switch (jurisdiction) {
        case jurisdictions_constants.Jurisdiction.AGCO: {
            if (isFirstLogin(loginRecords)) {
                return { closeDelay: magicMessaging.NotificationDelay.PERMANENT };
            }
            return {};
        }
        default: {
            return {};
        }
    }
}
function isFirstLogin(loginRecords) {
    return !loginRecords || loginRecords.length <= 1;
}

exports.getWelcomeNotificationKey = getWelcomeNotificationKey;
exports.getWelcomeNotificationOptions = getWelcomeNotificationOptions;
exports.getWelcomeNotificationParams = getWelcomeNotificationParams;
